import { Component, ViewChild, OnInit, LOCALE_ID, Inject, OnDestroy } from '@angular/core';
import { DataService } from '../services/data.service';
import { createAlertConfig } from '../shared/factoryconfigAlert';
import { NwbAlertService } from '@wizishop/ng-wizi-bulma';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { takeUntil, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  socio: any;
  associazione: any;
  
  nazioni: any[];
  associazioni: any[];

  @ViewChild('formindirizzo')
  formToSend: NgForm;

  @ViewChild('formcontatti')
  formContattiToSend: NgForm;

  editIndirizzo: boolean = false;
  editContatti: boolean = false;
  editConvenzione: boolean = false;
  
  dateModel: Date;
  dateFake: string;

  yearRange: string = "1900:2030";

  socio$: Observable<any>;

  constructor(private dataService: DataService,
    private alertservice: NwbAlertService,
    private route: ActivatedRoute, @Inject(LOCALE_ID) private locale: string) {
  }

  ngOnInit() {
    let currentYear = moment().year();
    this.yearRange = `${(currentYear - 110)}:${currentYear}`;
    
    this.route.data.subscribe(t => {
      if (!t || !t.dataDash || t.dataDash.lenght == 0) return;

      this.nazioni = t.dataDash[0];
      this.associazioni = t.dataDash[1];
      
      
    });
    

    this.socio$ = this.dataService.getData().pipe(tap((socio) => {
      this.socio = socio;
      if (this.socio.natoIl) {
        this.dateModel = new Date(this.socio.natoIl);

        let m = moment(this.dateModel);
        m.locale(this.locale);
        this.dateFake = m.format('ll');
      } else {
        this.dateFake = "";
      }
    }));
  
  }

  setTessera() {
    if (!this.socio.idAssociazione) {
      this.socio.nomeAssociazione = undefined;
      this.socio.tesseraAssociazione = undefined;
    }

    this.dataService.setAssociazione(this.socio).subscribe(() => {
      this.alertservice.open(createAlertConfig("Informazioni associazione aggiornata", true)).afterClosed().subscribe();
      this.editConvenzione = false;
    });
  }

  setContatti() {
    if (this.formContattiToSend.invalid) {
      this.alertservice.open(createAlertConfig("Controllare i campi", false)).afterClosed().subscribe();
      return;
    }

    this.dataService.setContatti(this.socio).subscribe(() => {
      this.alertservice.open(createAlertConfig("Contatti aggiornati", true)).afterClosed().subscribe();
      this.editContatti = false;
    });
  }

  enableDisableEditIndirizzo() {
    this.editIndirizzo = !this.editIndirizzo;
    if (this.socio.natoIl) {
      this.dateModel = new Date(this.socio.natoIl);

      let m = moment(this.dateModel);
      m.locale(this.locale);
      this.dateFake = m.format('ll');
    } else {
      this.dateFake = "";
    }
  }

  setIndirizzo() {
    if (this.formToSend.invalid) {
      this.alertservice.open(createAlertConfig("Controllare i campi", false)).afterClosed().subscribe();
      return;
    }
    let m = moment(this.dateModel);
    m.locale(this.locale);
    this.socio.natoIl = m.format('YYYY-MM-DD');
    this.dateFake = m.format('ll');
    this.dataService.setIndirizzo(this.socio).subscribe(() => {
      this.alertservice.open(createAlertConfig("Anagrafica aggiornata", true)).afterClosed().subscribe();
      this.editIndirizzo = false;
    });
  }

  onChangeAssociazione(event: any, associazione: any) {
    if (event) {
      let associazioneNuova = this.associazioni.find(a => a.id == event);
      this.socio.idAssociazione = associazioneNuova.id;
      this.socio.nomeAssociazione = associazioneNuova.ragioneSociale;
    } else {
      this.socio.idAssociazione = this.socio.tesseraAssociazione = this.socio.nomeAssociazione = undefined;
    }
  }


}
